import React from 'react';
import DaumPostcode, { Address } from 'react-daum-postcode';

import { colors } from 'inpock-ui-react/dist/src/color';

interface PostcodePageProps {
  onComplete: (result: { address: string; postcode: string }) => void;
}

interface PostcodeProps {
  onComplete: (result: { address: string; postcode: string }) => void;
}

function Postcode(props: PostcodeProps) {
  const handleComplete = (data: Address) => {
    let fullAddress = data.address;
    let extraAddress = '';

    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname;
      }
      if (data.buildingName !== '') {
        extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
    }

    props.onComplete({ address: fullAddress, postcode: data.zonecode });
  };

  const _props = {
    style: {
      width: '100%',
      height: '100%',
    },
    theme: {
      bgColor: colors.gray100, //바탕 배경색
      //searchBgColor: "", //검색창 배경색
      contentBgColor: colors.white, //본문 배경색(검색결과,결과없음,첫화면,검색서제스트)
      pageBgColor: colors.white, //페이지 배경색
      textColor: colors.gray800, //기본 글자색
      queryTextColor: colors.gray800, //검색창 글자색
      postcodeTextColor: colors.orange, //우편번호 글자색
      //emphTextColor: "", //강조 글자색
      outlineColor: colors.gray400, //테두리
    },
    focusInput: true,
    // hideMapBtn: true,
    // hideEngBtn: true,
    submitMode: false,
    useBannerLink: false,
  };

  return <DaumPostcode onComplete={handleComplete} autoClose onClose={() => {}} {..._props} />;
}

export function PostcodePage(props: PostcodePageProps) {
  return <Postcode onComplete={props.onComplete} />;
}
